import { css as reactCss } from '@emotion/react';

import { useTranslate } from '~src/main/context/localization';
import { useGlobalState } from '~src/main/context/global-state';
import { SwanLogo } from '~src/main/icons/swan-logo';
import { Dialog } from '~src/main/dialog/dialog';
import { DialogLayout } from '~src/main/dialog/dialog-layout';
import { FullscreenComponent } from '~src/main/fullscreen-internals/fullscreen-component';

interface SwanLabelModalProps {
  onClose: () => void;
}

const bulletPoints = [
  'widget.LABEL_MODAL.SWAN.BULLET_POINT_1',
  'widget.LABEL_MODAL.SWAN.BULLET_POINT_2',
];

export const SwanLabelModalFullscreen: FullscreenComponent<SwanLabelModalProps> = ({ onClose }) => {
  const globalState = useGlobalState();
  const tICU = useTranslate();

  return (
    <Dialog width={520} onClose={() => onClose()}>
      <DialogLayout
        title={
          <div css={styles.modalTitleWrapper}>
            <SwanLogo width={32} height={32} />
            <span css={styles.modalTitle}>{tICU('widget.LABEL_MODAL.SWAN.TITLE')}</span>
          </div>
        }
        onClose={() => onClose()}
      >
        <div css={styles.modal}>
          <div css={styles.modalBody}>
            <span>{tICU('widget.LABEL_MODAL.SWAN.DESCRIPTION')}</span>
            <ul css={styles.list}>
              {bulletPoints.map(bp => (
                <li key={bp}>{tICU(bp)}</li>
              ))}
            </ul>
          </div>
          <a
            css={styles.anchor}
            href={
              globalState.country === 'SE'
                ? 'https://www.svanen.se/'
                : 'https://www.nordic-swan-ecolabel.org/'
            }
            rel="noreferrer noopener"
            target="_blank"
          >
            {tICU('widget.LEARN_MORE')}
          </a>
        </div>
      </DialogLayout>
    </Dialog>
  );
};
SwanLabelModalFullscreen.fullscreenName = 'SwanLabelModal';

const styles = {
  modal: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  modalTitleWrapper: reactCss({
    fontVariationSettings: '"wght" 500',
    display: 'flex',
    alignItems: 'center',
  }),
  modalTitle: {
    marginLeft: '12px',
  },
  modalBody: {
    paddingTop: '16px',
  },
  list: {
    paddingLeft: '24px',
  },
  anchor: {},
};
